import { AsyncAction } from '@cbgms/base/redux/async-action'
import {
  GETSchedulerSettingsResponse,
  PUTSchedulerSettingsRequest,
  PUTSchedulerSettingsResponse,
  getSchedulerSettingsRequest,
  updateSchedulerSettingsRequest
} from '@cbgms/api/modules/scheduler'

const UPDATE_SCHEDULER_SETTINGS = 'UPDATE_SCHEDULER_SETTINGS'
const UPDATE_SCHEDULER_SETTINGS_SUCCESS = 'UPDATE_SCHEDULER_SETTINGS_SUCCESS'
const UPDATE_SCHEDULER_SETTINGS_FAILED = 'UPDATE_SCHEDULER_SETTINGS_FAILED'

export const updateSchedulerSettings = (schedulerSettings: PUTSchedulerSettingsRequest) =>
  AsyncAction<PUTSchedulerSettingsResponse>({
    type: [UPDATE_SCHEDULER_SETTINGS, UPDATE_SCHEDULER_SETTINGS_SUCCESS, UPDATE_SCHEDULER_SETTINGS_FAILED],
    payload: {
      api: 'gms',
      request: updateSchedulerSettingsRequest(schedulerSettings)
    }
  })

const LOAD_SCHEDULER_SETTINGS = 'LOAD_SCHEDULER_SETTINGS'
const LOAD_SCHEDULER_SETTINGS_SUCCESS = 'LOAD_SCHEDULER_SETTINGS_SUCCESS'
const LOAD_SCHEDULER_SETTINGS_FAILED = 'LOAD_SCHEDULER_SETTINGS_FAILED'

export const loadSchedulerSettings = () =>
  AsyncAction<GETSchedulerSettingsResponse>({
    type: [LOAD_SCHEDULER_SETTINGS, LOAD_SCHEDULER_SETTINGS_SUCCESS, LOAD_SCHEDULER_SETTINGS_FAILED],
    payload: {
      api: 'gms',
      request: getSchedulerSettingsRequest()
    }
  })
